import { ITablesRelated, TabsActionMODAL } from "src/pages/Actions/Panel/interface";
import { ReactNode } from "react";
import { IDateInitial } from "../../Actions/Panel/interface";
import { IPhases } from "../Project/Components/Phases/interface";
import { IProgram } from "../Program/interface";
import { IProject } from "../Project/interface";
import { ProjectSituationFilter } from "./Components/ListProjectsLevel/interface";

export interface IFiltersProjectPanel{
    f: string;
    responsible: string | undefined;
	authority: string | undefined;
	sector: string | undefined;
    situation: {
        value: string;
        label: string;
    }[] | string | undefined;
    startDate: Date | null;
    endDate: Date | null;
    tags: string | undefined;
    map: string | undefined;
    perspective: string | undefined;
    objective: string | undefined;
    program: string | undefined;
    project: string | undefined;
    delayed: string | undefined;
}

export enum ProjectSituation{
    OPEN = "1",
    CLOSED = "2"
}

export enum ProjectModel{
    TRADITIONAL = 1,
    AGILE = 2
}

export interface IListProgram{
    program: IProgram;
    filters: IFiltersProjectPanel;
    layoutList: "card" | "list";
    onCallbackProgram: (programId: number) => void;
    openModalAction?: () => void;
    openModalAddSprint?: (project: IProject) => void;
    openModalChangeSprint?: (phaseId: number, project: IProject) => void;
    openModalDeleteProject?: (projectId: number, projectName: string, programId: number, onCallback?: Function) => void;
    openModalChangeProject?: (projectId: number, copy: boolean) => void;
    openModalAddProject?: (program: IProgram) => void;
    openModalChangeProgram?: (programId: number) => void;
    openModalDeleteProgram?: (program: IProgram, onCallback?: Function) => void;
    onCallbackChangeProgram?: (program: IProgram) => void;
    onCallbackDeleteProgram?: (program: IProgram) => void;
    onCallbackChangeProject?: (project: IProject) => void;
    openModalDetails?: (id: number, type: "project" | "phase", title: string, controlHours: boolean, onCallback?: Function) => void;
    openModalReleaseActions?: (phase: any, onCallback?: Function) => void;
    openModalReorderProjects?: (program: IProgram) => void;
    openModalGantt?: ((id: number, title: string, level?: "project" | "program" | "phase") => void);
}

export interface IListProject{
    project: IProject;
    filterList?: ProjectSituationFilter;
    options: (row: any) => ReactNode;
    colorSituation: string;
    onCallbackProgram: (programId: number) => void;
    openModalAction?: () => void;
    openModalAddSprint?: (project: IProject) => void;
    openModalChangeSprint?: (phaseId: number, project: IProject) => void;
    openModalChangeProject?: (projectId: number, copy: boolean) => void;
    openModalDeleteProject?: (projectId: number, projectName: string, programId: number) => void;
    onCallbackChangeProject?: (project: IProject) => void;
    openModalDetails?: (id: number, type: "project" | "phase", title: string, controlHours: boolean, onCallback?: Function) => void;
    openModalReleaseActions?: (phase: any) => void;
    openModalGantt?: ((id: number, title: string, level?: "project" | "program" | "phase") => void);
}

export interface IListOfProject{
    projects: IProject[];
    filterList?: ProjectSituationFilter;
    layoutList: "card" | "list";
    onCallbackProgram: (programId: number) => void;
    openModalAction?: () => void;
    openModalAddSprint?: (project: IProject) => void;
    openModalChangeSprint?: (phaseId: number, project: IProject) => void;
    openModalChangeProject?: (projectId: number, copy: boolean) => void;
    openModalDeleteProject?: (projectId: number, projectName: string, programId: number) => void;
    onCallbackChangeProject?: (project: IProject) => void;
    openModalDetails?: (id: number, type: "project" | "phase", title: string, controlHours: boolean, onCallback?: Function) => void;
    openModalReleaseActions?: (phase: any) => void;
    showBudget: (group: number, title: string, programId: number, projectId?: number) => void;
    openModalGantt?: ((id: number, title: string, level?: "project" | "program" | "phase") => void);
}

export interface IListPhase{
    project: IProject;
    phase: IPhases;
    phaseAgile?: PhaseAgile;
    onCallbackProgram: (programId: number) => void;
    openModalReleaseActions?: (phase: any, onCallback?: Function) => void;
    openModalChangeSprint?: (phaseId: number, project: IProject) => void;
    openModalDetails?: (id: number, type: "project" | "phase", title: string, controlHours: boolean, onCallback?: Function) => void;
    openModalAction?: (id?: number, onCallback?: Function, tabInitSelected?: TabsActionMODAL | undefined, parentAction?: undefined | number, tablesRelated?: ITablesRelated, subtitle?: string, dateInitial?: IDateInitial) => void;
    onCallbackChangeProject: ((project: IProject) => void) | undefined;
    requestQuery?: (id: number) => void
    openModalGantt?: ((id: number, title: string, level?: "project" | "program" | "phase") => void);
}

export enum PhaseAgile{
    BACKLOG = 1,
    SPRINT = 2
}
